import { ContainersOption } from '../models/containers';

export const CONTAINERS: Array<ContainersOption> = [
  {
    sys_id: 1,
    capacity: {
      bucket : 2.4,
      sausage : 0.6,
      tin : 0.75,
      tape : 10,
    },
    usage: {
      bucket : 2.4,
      sausage : 0.6,
      tin : 39,
      tape : 10,
    }
  },
  {
    sys_id: 2,
    capacity: {
      bucket : 2.4,
      sausage : 0.6,
      tin : 0.86,
      tape : 10,
    },
    usage: {
      bucket : 2.4,
      sausage : 0.6,
      tin : 50,
      tape : 10,
    }
  },
  {
    sys_id: 3,
    capacity: {
      bucket : 2.4,
      sausage : 0.6,
      tin : 0.75,
      tape : 10,
    },
    usage: {
      bucket : 2.4,
      sausage : 0.6,
      tin : 39,
      tape : 10,
    }
  },
];
